<template>
  <div>
    <SelectGroup :options="filteredOptions"
                 variant="white"
                 :title="null"
                 :label="object.operation_type == 'movement_from' ? $t('from_where') : $t('warehouse')"
                 :translate="false"
                 :required="true"
                 :showlabel="true"
                 v-model="object.warehouse_id"/>
    <ValidationError validation-id="warehouse_id"/>
    <SelectGroup v-if="filteredOptions.length > 0 && type == 'movement_from'"
                 :options="filteredOptions"
                 variant="white"
                 :title="null"
                 :required="true"
                 :label="$t(field.title)"
                 :translate="false"
                 :showlabel="true"
                 v-model="object.related_warehouse_id"/>
  </div>
</template>

<script>
import SelectGroup from "@/components/form/SelectGroup"
import ValidationError from "@/components/form/ValidationError"

export default {
  name: "WarehouseDatatableFormDestinationWarehouse",
  components: {
    ValidationError,
    SelectGroup
  },
  props: {
    object: {
      type: Object
    },
    selectOptions: {},
    field: {},
    required: {},
    value: {},
    selectModels: {}
  },
  methods: {
  },
  mounted() {
  },
  computed: {
    relatedWarehouse() {
      return this.object.related_warehouse_id
    },
    mainWarehouse() {
      return this.object.warehouse_id
    },
    mainWarehouseObject() {
      return this.mainWarehouse ? this.selectOptions.find(obj => Number(obj.id) === Number(this.mainWarehouse)) : null
    },
    type() {
      return this.object.operation_type
    },
    filteredOptions() {
      return this.selectOptions
          .filter(obj => this.type === 'write_off' || !obj.deleted_at)
          .map(obj => ({
            id: obj.id,
            title: `${obj.title}${obj.deleted_at ? ' ('+this.$t('is_deleted')+')' : ''}`
          }))
    }
  },
  watch: {
    relatedWarehouse(val) {
      if(val && val == this.object.warehouse_id) {
        this.object.related_warehouse_id = null
      }
    },
    mainWarehouse(val) {
      if(this.object.related_warehouse_id && this.object.related_warehouse_id == val) {
        this.object.related_warehouse_id = null
      }
    },
    type(val) {
      if(val != 'movement_from') {
        this.object.related_warehouse_id = null
      }
      if(val != 'write_off' && this.mainWarehouseObject?.deleted_at) {
        this.object.warehouse_id = null
      }
    }
  }
}
</script>
